import React from 'react';
import PropTypes from 'prop-types';
import AuthWrapperComponent from '../../../CallToAction/AuthWrapperComponent/AuthWrapperComponent';
import LikeHeart from '../../../Icons/LikeHeart';
import { JobContext } from '../../../../contexts/ContextCreator';

import './JobLikeReaction.scss';

const determineJobLikedStatus = (hash, content = []) => {
    if (!content || content.length === 0) return false;
    const currentJob = content.find((job) => job.hash === hash);
    return currentJob ? currentJob.userLiked : false;
};

export const JobLikeReaction = ({ hash }) => {
    const jobContext = React.useContext(JobContext);

    const { toggleJobLike, content } = jobContext;

    const handleClick = React.useCallback(() => toggleJobLike(hash), [
        toggleJobLike,
        hash,
    ]);

    // bail if we're on a page not wrapped in a job context provider
    if (!jobContext) return null;

    const isActive = determineJobLikedStatus(hash, content);

    return (
        <AuthWrapperComponent
            callToActionHash="save-job"
            loginTrigger="save-job"
        >
            <button
                type="button"
                className="component-JobV3-Elements-JobLikeReaction"
                onClick={handleClick}
            >
                <LikeHeart isActive={isActive} className="job-like-icon" />
            </button>
        </AuthWrapperComponent>
    );
};

JobLikeReaction.propTypes = {
    hash: PropTypes.string.isRequired,
};

JobLikeReaction.defaultProps = {};

JobLikeReaction.displayName = 'JobLikeReaction';

export default React.memo(JobLikeReaction);
